import React, { useState } from "react";
import InView from "react-intersection-observer";
import CSEBPlatformImage from "../../images/business-img.jpeg";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import LazyLoad from 'react-lazyload';

export default function KrogerCsEbusiness() {
  const [isVisible, setIsVisible] = useState({ one: false, two: false });
  return (
    <InView as="div" className="cs-business-section section-gap" onChange={(inView) => setIsVisible(prev => { return { ...prev, one: inView }; })} threshold={[0.2]}>
      <div className="cs-business-image">
        <LazyLoad>
          <img src={CSEBPlatformImage} className="cb-business-image" alt="custom voice automation retail" title="Custom Voice Automation" />
        </LazyLoad>
        <div className="tagline">
          <h5>{isVisible ? <HeaderAnim header="Hey Google, add mozzarella to my list" /> : ""}</h5>
        </div>
      </div>
      <div className="container">
        <InView as="div" className="row justify-center d-flex" onChange={(inView) => setIsVisible(prev => { return { ...prev, two: inView }; })} threshold={[0.2]}>
          <div className="col cs-business-content">
            <h5 className="small-title">A NEW platform for growth</h5>
            <h2>Voice commerce is the new frontier</h2>
            <p>We learned that voice is going to be a unique opportunity, and it will need a solid tech foundation to support the growth. We came with the platform strategy - launch personalized and voice-enabled products and services by enabling the platform economics - scale, speed, re-usability, and cost savings.</p>
            <p>We integrated the client’s internal systems, developed new modules, and delivered a strong foundation for delivering flawless and conversational experiences across multiple channels.</p>
          </div>
        </InView>
      </div>
    </InView>
  );
}